import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useResults } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import { CONTENT_PAGES_SOURCE_ID } from "@/components/Search/SearchBar/config/searchBar.config";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { items } = useResults(CONTENT_PAGES_SOURCE_ID);

    if (items.length === 0) return null;

    return <div className={cn(className)}>{children}</div>;
};
